import { useContext, useEffect, useState } from "react";
import CheckboxField from "../../../../components/checkboxField/checkboxField";
import { CheckboxFieldProps } from "../../../../components/checkboxField/types/checkboxFieldProps";
import ButtonField from "../../../../components/buttonField/buttonField";
import { ReactComponent as searchIcon } from '../../../../icons/search.svg';
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import { ReasearchButtons } from "../types/krFormView";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { stylizationVerticalAlign } from "../../../../components/shared/stylization";
import Table from "../../../../components/shared/table/table";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import { HeadersTable } from "../../../../helpers/featureTableConstruct";
import KrFormContext, { NavHeadingsKROEnum, KrFormContextLandslideType, LandslidePublications, LandslideResearch, ResearchCategories } from "../../../../contexts/krFormContext";
import { SearchDocumentModalProps } from "./modals/searchDocumentModal/types/searchDocumentModalProps";
import SearchDocumentModal from "./modals/searchDocumentModal/searchDocumentModal";
import { notifyError } from "../../../../components/snackbar/snackbar";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import SearchPublicationModal from "./modals/searchPublicationModal/searchPublicationModal";
import { SearchPublicationModalProps } from "./modals/searchPublicationModal/types/searchPublicationModalProps";
import AddDocumentProposalModal from "./modals/addDocumentModal/addDocumentProposalModal";
import AddPublicationProposalModal from "./modals/addPublicationProposalModal/addPublicationProposalModal";
import './../krFormView.scss';
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import PermissionsContext from "../../../../contexts/permissionsContext";
import CollectiveLabelChip from "../../collectiveEditionView/components/collectiveLabelChip";
import { FormSectionProps } from "./shared/types/formSectionProps";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { checkIfMarkedForCommentFilter, fireAddCommentBtnOnClickForRow, getFieldRef, getFieldRefForRow, getItemRef, getKRDictFieldNameForRow, renderSectionCommentBtn } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import { GetOptions } from "../../../../helpers/prepareForSelect";

const ResearchState = (props: FormSectionProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const { functionsPermissions } = useContext(PermissionsContext) 
    const [sectionToggleCheckbox, setSectionToggleCheckbox] = useState(true);
    const [activeBtn, setActiveBtn] = useState<ReasearchButtons | null>(null);
    const [researchRow, setResearchRow] = useState<any>(null);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [tableData, setTableData] = useState<LandslideResearch[]>([]);
    const [rowsToFoldOut, setRowsToFoldOut] = useState<string[]>([]);
    const [visibilityRows, setVisibilityRows] = useState<string[]>([]);
    const [tableError, setTableError] = useState<boolean>(false);
    const [tableErrorMsg, setTableErrorMsg] = useState<string>('');
    const [focusAddDocBtn, setFocusAddDocBtn] = useState<boolean>(false);
    const [focusAddPubBtn, setFocusAddPubBtn] = useState<boolean>(false);
    const [focusSearchDocBtn, setFocusSearchDocBtn] = useState<boolean>(false);
    const [focusSearchPubBtn, setFocusSearchPubBtn] = useState<boolean>(false);
    const [focusTable, setFocusTable] = useState<boolean>(false);
    const [showTable, setShowTable] = useState(false);

    var publicationsDict = GetOptions("TYP_PUBLIKACJI_SID", krForm.dictionaries, true);

    const refocus = () => {
        setFocusTable(true);
    }

    const refocusAddDocBtn = () => {
        setFocusAddDocBtn(true);
    }

    const refocusAddPubBtn = () => {
        setFocusAddPubBtn(true);
    }

    const refocusSearchDocBtn = () => {
        setFocusSearchDocBtn(true);
    }

    const refocusSearchPubBtn = () => {
        setFocusSearchPubBtn(true);
    }

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            const currValidation = createConfigValidation("publications", false);
            const values: any[] = [];
            if(krForm.publications) values.push(krForm.publications);
            if(krForm.documents) values.push(krForm.documents);
            const errorMsg = validation(currValidation, values);
            if (errorMsg !== '') {
                setTableError(true);
                setTableErrorMsg(errorMsg);
            }
        }  
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const refreshValidation = (values: any[] | undefined, valuesRes: any[] | undefined) => {
        values = values?.concat(valuesRes);
        const currValidation = createConfigValidation("publications", false);
        const currValidationMsg = validation(currValidation, values);
        if (currValidationMsg) {
            setTableError(true);
            setTableErrorMsg(currValidationMsg);
        } else {
            setTableError(false);
            setTableErrorMsg('');
        }
    }
    
    // Toggle section checkbox
    useEffect(() => {
        if ((krForm.documents && krForm.documents.length > 0) || (krForm.publications && krForm.publications.length > 0) || 
        (krForm.landslideAttributes?.bibliografia && krForm.landslideAttributes.bibliografia !== "Brak informacji o prowadzonych badaniach osuwiska")) {
            setSectionToggleCheckbox(false);
            if((krForm.documents && krForm.documents.length > 0) || (krForm.publications && krForm.publications.length > 0)){
                setShowTable(true);
            }
        }
        else if ((!krForm.documents || krForm.documents.length === 0) && (!krForm.publications || krForm.publications.length === 0)) {
            setSectionToggleCheckbox(true);
            var form: any = Object.assign({}, krForm);
            form.landslideAttributes.bibliografia = "Brak informacji o prowadzonych badaniach osuwiska";
            setkrForm(form); 
            setShowTable(false);
        }
        prepareTableData();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.documents, krForm.publications]);

    const onChangeCheckbox = (e: any) => {
        setSectionToggleCheckbox(!sectionToggleCheckbox);
        var form: any = Object.assign({}, krForm); 
        if (!sectionToggleCheckbox) {
            if (form.documents && form.documents.length > 0) form.documents = [];
            if (form.publications && form.publications.length > 0) form.publications = [];
            form.landslideAttributes.bibliografia = "Brak informacji o prowadzonych badaniach osuwiska";
            setkrForm(form);
            setShowTable(false);
        }
        else{
            form.landslideAttributes.bibliografia = "";
            setkrForm(form);
        }
    }
    
    var checkboxFieldPropsResearchStateToggle: CheckboxFieldProps = {
        disabled: !props.editMode,
        labelName: "Brak informacji o prowadzonych badaniach osuwiska",
        inputChecked: sectionToggleCheckbox,
        onChange: onChangeCheckbox
    }

    // Search & add document / publication buttons 
    const getBtnProps = (title: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>, 
        onClick: React.MouseEventHandler<HTMLButtonElement>, refocus?: boolean, setRefocusButton?: Function): ButtonFieldProps => {
        let className = classNameBtn.BigSecondary + " body-txt-XL";

        return {
            BtnProps: {
                onClick: onClick,
                style: {
                    width: '100%',
                    height: '86px'
                },
                className: className
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
            refocus: refocus,
            setRefocusButton: setRefocusButton
        };
    }

    const searchDocument = () => {
        setActiveBtn(ReasearchButtons.SearchDocument);
    }

    const addDocument = () => {
        setActiveBtn(ReasearchButtons.AddDocumentProposal);
    }

    const searchPublication = () => {
        setActiveBtn(ReasearchButtons.SearchPublication); 
    }

    const addPublication = () => {
        setActiveBtn(ReasearchButtons.AddPublicationProposal);
    }   

    // Research table
    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"research"}
            deleteClickHandler={handleDeleteClick}
            visibilityClickHandler={handleVisibilityClick}
            visibilityRows={visibilityRows}
            closeClickHandler={handleCloseClick}
            addCommentBtnVisible={!props.editMode}
            addCommentBtnClickHandler={handleAddCommentClick}
            addCommentBtnRef={getAddCommentBtnRef}
            checkIfMarkedForCommentFilter={checkIfRowMarkedForCommentFilter}
        />)
    }

    const checkIfRowMarkedForCommentFilter = (row: any) => {
        if (props.markedFieldForCommentFiltering) {
            return checkIfMarkedForCommentFilter(KROFieldDict.stanBadan_stanBadan, row.itemGlobalId, props.markedFieldForCommentFiltering)
        }
    }

    const handleDeleteClick = (row: any) => {
        setResearchRow(row);
        setConfirmation(true); 
    }

    const handleAddCommentClick = (row: any) => {
        fireAddCommentBtnOnClickForRow(KROFieldDict.stanBadan_stanBadan, row.itemGlobalId, 
            "Wiersz sekcji: Stan badań", 
            props.setNewCommentFieldDetails!);
    }

    const getAddCommentBtnRef = (node: any, row: any) => {
        getFieldRefForRow(node, KROFieldDict.stanBadan_stanBadan, row.itemGlobalId, props.getMapForComment!);
    }

    const deleteResearch = (row: any) => {
        var form: any = Object.assign({}, krForm);       
        if (form !== null) {
            switch(row.category) {
                case ResearchCategories.Document: {
                    form.documents = form.documents.filter((item: any) => `${item.id}_${item.source}` !== row.itemGlobalId)
                    break;
                }                   
                case ResearchCategories.Publication: {
                    form.publications = form.publications.filter((item: any) => item.publikacE_SOPO_GID !== row.itemGlobalId)
                    break;
                } 
            }
        }
        refreshValidation(form.documents, form.publications);
        setkrForm(form);
    }

    const confirm = () => {
        setConfirmation(false);
        deleteResearch(researchRow);
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć badanie ${researchRow.title}?`;
    }

    const handleVisibilityClick = (row: any) => {  
        setRowsToFoldOut([...rowsToFoldOut, row.itemGlobalId]);  
        setVisibilityRows([...visibilityRows, row.itemGlobalId]);
    }

    const handleCloseClick = (row: any) => {  
        setRowsToFoldOut([...rowsToFoldOut.filter((item: any) => item !== row.itemGlobalId)]);  
        setVisibilityRows([...visibilityRows.filter((item: any) => item !== row.itemGlobalId)]);
    }
    
    const getNamePublicationType = (publicationType: number | null | undefined) => {
        return publicationsDict?.find((value) => value.value === publicationType)?.name;
    }

    const prepareFoldoutContent = (row: any) => {  
        switch(row.category) {
            case ResearchCategories.Document:
                var documentDict = krForm.documents?.find((item) => `${item.id}_${item.source}` === row.itemGlobalId);
                return (
                    <>
                        <div className="foldout-table body-txt-medium-xs">
                            <div>   
                                <table><tbody>
                                    <tr>
                                        <th><span>Tytuł</span> </th>
                                        <td>{documentDict?.tytul}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Rok</span> </th>
                                        <td>{documentDict?.rok}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Autorzy</span> </th>
                                        <td>{documentDict?.autorzy}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Numery inwentarzowe</span> </th>
                                        <td>{documentDict?.nR_INWENTARZOWY}</td>
                                    </tr>
                                </tbody></table>
                            </div>
                            <div>   
                                <table><tbody>
                                    <tr>
                                        <th><span>Nazwa archiwum</span> </th>
                                        <td>{documentDict?.nazwA_ARCHIWUM}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Adres archiwum</span> </th>
                                        <td>{documentDict?.adreS_ARCHIWUM}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Nazwa firmy</span> </th>
                                        <td>{documentDict?.nazwA_FIRMY}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Uwagi</span> </th>
                                        <td>{documentDict?.uwagi}</td>
                                    </tr>
                                </tbody></table>
                            </div>
                        </div>
                    </>
                );
            case ResearchCategories.Publication:
                var publicationDict = krForm.publications?.find((item) => item.publikacE_SOPO_GID === row.itemGlobalId);
                return (
                    <>
                        <div className="foldout-table body-txt-medium-xs">
                            <div>   
                                <table><tbody>
                                    <tr>
                                        <th><span>Tytuł</span> </th>
                                        <td>{publicationDict?.details?.publikacjA_SOPO}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Typ publikacji</span> </th>
                                        <td>{getNamePublicationType(publicationDict?.details?.tyP_PUBLIKACJI_SID)}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Rok</span> </th>
                                        <td>{publicationDict?.details?.roK_POWSTANIA}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Autorzy</span> </th>
                                        <td>{publicationDict?.details?.autorzy}</td>
                                    </tr>
                                </tbody></table>
                            </div>
                            <div>   
                                <table><tbody>
                                    <tr>
                                        <th><span>Nazwa czasopisma</span> </th>
                                        <td>{publicationDict?.details?.czasopismO_NAZWA}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Oznaczenie czasopisma</span> </th>
                                        <td>{publicationDict?.details?.czasopismO_OZNACZENIE}</td>
                                    </tr>
                                    <tr>
                                        <th><span>Nazwa wydawnictwa</span> </th>
                                        <td>{publicationDict?.details?.wydawnictwO_NAZWA}</td>
                                    </tr>
                                </tbody></table>
                            </div>
                        </div>
                    </>
                );
        }
    }

    let headers = {
        category: "Kategoria",
        year: "Rok",
        authors: "Autorzy",
        title: "Tytuł"
    };

    const prepareTableData = () => {
        var data: LandslideResearch[] = [];
        krForm.publications?.forEach((element) => {
            data.push({
                category: ResearchCategories.Publication,
                year: element.details?.roK_POWSTANIA,
                authors: element.details?.autorzy,
                title: element.details?.publikacjA_SOPO,
                itemGlobalId: element.publikacE_SOPO_GID
            });
        })
        krForm.documents?.forEach((element) => {
            data.push({
                category: ResearchCategories.Document,
                year: element.rok,
                authors: element.autorzy,
                title: element.tytul,
                itemGlobalId: `${element.id}_${element.source}`
            });
        })

        var docsWithNoYear = data.filter(item => item.year === null || item.year === undefined);
        var docsWithYear = data.filter(item => !docsWithNoYear.includes(item));
        docsWithYear.sort((a, b) => { return a.year! - b.year!; });
        data = docsWithYear.concat(docsWithNoYear);
               
        setTableData(data);
    }

    const foldoutParamToCheck = (row: any) => {
        return row.itemGlobalId;
    }

    var tablePropsResearchTable: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: tableData,
        loading: false,
        className: "table",
        foldoutRows: true,
        rowsToFoldOut: rowsToFoldOut,
        foldoutContent: prepareFoldoutContent,
        foldoutParamToCheck: foldoutParamToCheck,
        tableError: props.collectiveEdition ? undefined : tableError,
        tableErrorMsg: props.collectiveEdition ? undefined : tableErrorMsg,
        setCommentsFilter: (row: any) => { if (props.setCommentsFilter) props.setCommentsFilter(getKRDictFieldNameForRow(KROFieldDict.stanBadan_stanBadan, row.itemGlobalId)); },
        checkIfMarkedForCommentFilter: (row: any) => { checkIfRowMarkedForCommentFilter(row) },
        narrowTableForCommentBtns: !props.editMode,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    // Search document modal
    const onAddDocument = (item: any) => {      
        let document = krForm.documents?.filter((element) => element.tytul === item.tytul && element.rok === item.rok && element.autorzy === item.autorzy);
        if (document && document.length > 0)
        {
            notifyError({ message: `Wskazany dokument został już dodany` });
        }
        else
        {
            var form: any = Object.assign({}, krForm);
            item.osuwiskO_GID = krForm.landslideAttributes?.globalid
            form.documents = [...form.documents, item];
            refreshValidation(form.documents, form.publications);
            setkrForm(form);
        }
    }

    const onClose = () => {
        setActiveBtn(null);
    }
    
    let searchDocumentModalProps: SearchDocumentModalProps = {
        onClose: onClose,
        onAddDocument: onAddDocument,
        refocus: refocusSearchDocBtn
    };

    // Search publication modal
    const onAddPublication = (item: any) => {      
        let publication = krForm.publications?.filter((element) => element.publikacE_SOPO_GID === item.globalid);
        if (publication && publication.length > 0)
        {
            notifyError({ message: `Wskazana publikacja została już dodana` });
        }
        else
        {
            var form: any = Object.assign({}, krForm);
            var pub: LandslidePublications = {               
                osuwiskA_GID: krForm.landslideAttributes?.globalid,
                publikacE_SOPO_GID: item.globalid,
                details: item
            }
            form.publications = [...form.publications, pub]
            refreshValidation(form.documents, form.publications);
            setkrForm(form);
        }
    }

    let searchPublicationModalProps: SearchPublicationModalProps = {
        onClose: onClose,
        onAddPublication: onAddPublication,
        refocus: refocusSearchPubBtn
    };

    var textAreaBibliografiaProps: TextAreaFieldProps = {
            labelName: 'Bibliografia',
            textAreaPlaceholder: 'Dodaj bibliografię',
            textareaSharedProps: {
                className: 'body-txt-large',
                style: {
                    width: '100%',
                    minHeight: '85px'
                }
            },
            configValidation: undefined,
            validationError: undefined,
            disabled: false,
            pristine: true,
            setValue: (value: any) => {
                var form = Object.assign({}, krForm);
                if (form && form.landslideAttributes) {
                    form.landslideAttributes.bibliografia = value;
                    if(value && sectionToggleCheckbox && value !== "Brak informacji o prowadzonych badaniach osuwiska"){
                        setSectionToggleCheckbox(false);
                    }
                    else if (value === "Brak informacji o prowadzonych badaniach osuwiska" && !sectionToggleCheckbox){
                        setSectionToggleCheckbox(true);
                    }
                    else if (!value && !sectionToggleCheckbox){
                        if((!krForm.documents || krForm.documents.length === 0) && (!krForm.publications || krForm.publications.length === 0)){
                            setSectionToggleCheckbox(true);
                            form.landslideAttributes.bibliografia = "Brak informacji o prowadzonych badaniach osuwiska";
                        }
                    }
                    setkrForm(form);
                }
            },
            dynamicResize: true,
            value: krForm.landslideAttributes?.bibliografia
        }

    const renderBtns = () => {
        return <div className="researchBtns">
            <ButtonField {...getBtnProps("Szukaj dokumentu", searchIcon, searchDocument, focusSearchDocBtn, setFocusSearchDocBtn)} />
            <ButtonField {...getBtnProps("Szukaj publikacji", searchIcon, searchPublication, focusSearchPubBtn, setFocusSearchPubBtn)} />
            {functionsPermissions.proposeNewDictValue.active &&
                <>
                    <ButtonField {...getBtnProps("Dodaj dokument", addCircleIcon, addDocument, focusAddDocBtn, setFocusAddDocBtn)} />
                    <ButtonField {...getBtnProps("Dodaj publikację", addCircleIcon, addPublication, focusAddPubBtn, setFocusAddPubBtn)} />
                </>
            }
        </div>
    }

    return (
        <>
            <div ref={(node: any) => {if (!props.collectiveEdition) getFieldRef(node, KROFieldDict.stanBadan_sekcja, props.getMapForComment!)}} style={{ width: '100%' }}></div>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.ResearchState, props.getMapForNavScroll!)}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.stanBadan_sekcja); }}
                style={{ width: '100%' }}
            >13. Stan badań</h2>
            {props.collectiveEdition ? <>
                <div className='collective-block'>
                    <div className="collective-input">
                        <CollectiveLabelChip isAuto={false} />
                        <CheckboxField {...checkboxFieldPropsResearchStateToggle} />
                    </div>
                    {renderBtns()}
                </div>
                <CollectiveSelectField top={false} value={tableData} title={"Stan badań"}
                    forms={props.forms} keyName={CollectivePreviewKey.stanBadan} actions={props.actions} single={false}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <div style={{ width: '100%' }}><Table {...tablePropsResearchTable} /></div>
                </CollectiveSelectField>
            </> : <>
                {!props.editMode && renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.stanBadan_sekcja, false, "13. Stan badań", props.setNewCommentFieldDetails!, KROFieldDict.stanBadan_sekcja)}
                <CheckboxField {...checkboxFieldPropsResearchStateToggle} />
                {props.editMode && renderBtns()}
                {showTable && <><Table {...tablePropsResearchTable} /> <br /></>}
            </>
            }
            {confirmation && 
            <ConfirmModal width={"660px"} height={"auto"}
                confirmTitle={"Tak, usuń badanie"}
                onConfirm={confirm}
                cancelTitle={"Anuluj"}
                onCancel={cancel}
                question={getQuestion()}
                refocus={refocus}
            />}
            {activeBtn === ReasearchButtons.SearchDocument && <SearchDocumentModal {...searchDocumentModalProps} />}
            {activeBtn === ReasearchButtons.SearchPublication && <SearchPublicationModal {...searchPublicationModalProps} />}
            {activeBtn === ReasearchButtons.AddDocumentProposal && <AddDocumentProposalModal onClose={onClose} refocus={refocusAddDocBtn}/>}
            {activeBtn === ReasearchButtons.AddPublicationProposal && <AddPublicationProposalModal publicationsDict={publicationsDict} onClose={onClose} refocus={refocusAddPubBtn}/>}
            { (krForm.publications?.length === 0 
                && krForm.documents?.length === 0) && <TextAreaField {...textAreaBibliografiaProps} />}
        </>
    )
}

export default ResearchState;